import { toTwoDigitNumber } from 'tabs/topQuestions/utils/NumberUtil'
import dayjs from 'dayjs'

export type DateObject = {
  year: number
  month: number
  day: number
}

export function datesEqual(obj1: DateObject, obj2: DateObject) {
  return obj1.year === obj2.year && obj1.month === obj2.month && obj1.day === obj2.day
}

export function fromDayJsObject(day: dayjs.Dayjs): DateObject {
  const result = {
    day: day.date(),
    month: day.month() + 1,
    year: day.year(),
  }
  return result
}

export function toDayJsObject(obj: DateObject | undefined): dayjs.Dayjs {
  return obj != undefined ? dayjs(dateObjectToDate(obj)) : undefined
}


export function dateObjectToDate(dateObject: DateObject): Date {
  if (!dateObject) return undefined
  const { year, month, day } = dateObject

  // Create a Date object, with month - 1 because JavaScript's Date object uses 0-based months
  const date = new Date(year, month - 1, day)

  // Set the time to the start of the day (00:00:00)
  date.setHours(0, 0, 0, 0)

  return date
}

export function dateObjectFromDate(date: Date): DateObject {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  return { year, month, day }
}


export function formatDateObject(date: DateObject) {

  const year = toTwoDigitNumber(date.year)
  const month = toTwoDigitNumber(date.month - 1)
  const day = toTwoDigitNumber(date.day)
  return year + '-' + month + '-' + day
}

export function dateObjectTimestampSeconds(date: DateObject) {
  const { year, month, day } = date
  const dateValue = new Date(year, month - 1, day)
  dateValue.setHours(0, 0, 0, 0)
  return dateValue.getTime() / 1000
}

export function getCurrentDateMinusMonths(numOfMonths: number) {
  const currentDate = new Date()
  return new Date(currentDate.setMonth(currentDate.getMonth() - numOfMonths))
}

export function toDateObjectFromTimestamp(timestampSeconds: number): DateObject {
  const date = new Date(timestampSeconds * 1000)
  return dateObjectFromDate(date)
}

export function fromTimestampSeconds(seconds: number) {
  return new Date(seconds * 1000)
}

export function formatDate(dateValue: Date) {
  const date = dateObjectFromDate(dateValue)
  return formatDateObject(date)
}

export function* rangeBetweenDates(startTimestampSec: number,
                                   finishTimestampSec: number) {
  const currentDate = new Date(startTimestampSec * 1000)
  const endDate = new Date(finishTimestampSec * 1000)

  currentDate.setHours(0, 0, 0, 0)

  while (currentDate <= endDate) {
    yield formatDate(new Date(currentDate)) // Yield the current date
    currentDate.setDate(currentDate.getDate() + 1) // Move to the next day
  }
}
